import React, { Component } from 'react';

import './ResponseConditions.css';

import Condition from './Condition';

class ResponseConditions extends Component {

  static defaultProps = {
    titleCondition : [],
    toggleConditionModal : () => {
      console.error("toggleConditionModal props not deliveried to ResponseConditions");
    }
  }

  conditionsRender = () => {

    // const render = conditions.map( condition => {
    //   return (
    //     <Condition key="" />
    //   );
    // });
  }

  handleTitleClicked = (e) => {
    const { toggleConditionModal } = this.props;

    toggleConditionModal();
  }

  render() {
    const { titleCondition } = this.props;
    const { handleTitleClicked } = this;

    return (
      <div id="ResponseConditions"
        onClick={handleTitleClicked} >
        {/* <h2> {titleCondition.conditionText} </h2> */}
        {
          // TODO API로 받아온 값 Object로 변환 해주던가 코드 리팩토링 필요
          typeof titleCondition === "string" ?
          (
            <h5 className="condition-title"> {titleCondition} </h5>
          ) : (
            <h5 className="condition-title"> {titleCondition.condition} </h5>
          )
        }
      </div>
    );
  }
}

export default ResponseConditions;